import { ChangeDetectionStrategy, Component, Injector, input, OnDestroy, OnInit } from '@angular/core';
import { CustomOrderHistoryList, OrderUserProfileFilter } from '@order/const';
import { OnlineOrderService } from '@order/feature';
import { DeviceService } from '@shared/services';
import { ModalService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { OnlineOrdersFilterModalComponent } from './online-orders-filter/online-orders-filter-modal';
import { OnlineOrdersListComponentService } from './online-orders-list.component-service';

@Component({
  selector: 'sd-online-orders-list',
  templateUrl: './online-orders-list.component.html',
  styleUrls: ['./online-orders-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [OnlineOrdersListComponentService],
  standalone: false,
})
export class OnlineOrdersListComponent implements OnDestroy, OnInit {
  hideFilter = input(false);

  PAGE_SIZE = 20;
  SORT_TYPE = 'byDate';

  currentPage: number;
  orderUserProfileFilter = OrderUserProfileFilter.ALL;

  orders$: Observable<CustomOrderHistoryList>;
  isLoaded$: Observable<boolean>;
  isLoading$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  private subscription = new Subscription();

  constructor(
    private onlineOrderService: OnlineOrderService,
    private onlineOrdersListComponentService: OnlineOrdersListComponentService,
    private modalService: ModalService,
    private deviceService: DeviceService,
    private injector: Injector,
  ) {}

  ngOnInit(): void {
    this.orders$ = this.onlineOrderService.getOrderList();
    this.isLoaded$ = this.onlineOrderService.getOrderListLoaded();
    this.isLoading$ = this.onlineOrderService.getOrderListLoading();

    this.subscription.add(
      this.onlineOrdersListComponentService.getOrderUserProfileFilter().subscribe((orderTypeFilter) => {
        this.changeOrderType(orderTypeFilter);
      }),
    );

    this.isMobile$ = this.deviceService.isMobileSmDown$;
  }

  ngOnDestroy(): void {
    this.onlineOrderService.clearOrderList();
    this.subscription.unsubscribe();
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.fetchOrders();
  }

  changeOrderType(value: OrderUserProfileFilter): void {
    this.orderUserProfileFilter = value;
    this.fetchOrders();
  }

  fetchOrders(): void {
    this.onlineOrderService.loadOrderList({
      pageSize: this.PAGE_SIZE,
      orderType: this.orderUserProfileFilter,
      currentPage: this.currentPage,
      sort: this.SORT_TYPE,
    });
  }

  openFiltersModal(): void {
    this.modalService.open(OnlineOrdersFilterModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',
      windowClass: 'modal-facets',
      injector: this.injector,
    });
  }
}
